<template>
  <ButtonSecondary v-model="edit" @click="emitEvents">
    <template v-slot:button1>
      <EditIcon/>
    </template>
    <template v-slot:button2>
      <AcceptIcon/>
    </template>
    <template v-slot:button3>
      <DiscardIcon/>
    </template>
  </ButtonSecondary>
</template>

<script>
import ButtonSecondary from "./templates/SplitButton";
import EditIcon from "../icons/EditIcon";
import AcceptIcon from "../icons/AcceptIcon";
import DiscardIcon from "../icons/DiscardIcon";
import {computed} from "@vue/composition-api";

export default {
  name: "EditButton",
  components: {DiscardIcon, AcceptIcon, EditIcon, ButtonSecondary},
  props:{
    value: Boolean
  },
  setup(props, {emit}) {
    function emitEvents(buttonClicked) {
      switch (buttonClicked) {
        case 1:
          emit('edit')
          break
        case 2:
          emit('save')
          break
        case 3:
          emit('discard')
          break
      }
    }

    const edit = computed({
      get: () => props.value,
      set: (value) => {emit('input', value)}
    })

    return {emitEvents, edit}
  }
}
</script>

<style scoped lang="scss">
</style>

<!-- The following style have to be declared as global styles, otherwise they have no effect. -->
<style lang="scss">
.split-button-component .v-button-slit {
  svg.edit-icon {
    .a {
      stroke: #878787;
    }
  }

  &:hover {
    svg.edit-icon {
      .a {
        stroke: #050505;
      }
    }
  }
}
</style>
